import { render, staticRenderFns } from "./ButtonTooltip.vue?vue&type=template&id=5aeda1d6&scoped=true"
import script from "./ButtonTooltip.vue?vue&type=script&lang=js"
export * from "./ButtonTooltip.vue?vue&type=script&lang=js"
import style0 from "./ButtonTooltip.vue?vue&type=style&index=0&id=5aeda1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeda1d6",
  null
  
)

export default component.exports